module.exports = __webpack_public_path__ + "media/applicants/todayshow-69d8756e.jpg";